// TODO: Remove file in COTECH-2882
import { debounce } from "../../../../helpers/debounce";
import { tlbHasAdditionalOdysseyWrapper } from "../../helpers/tlbHasAdditionalOdysseyWrapper";

type TopMarginApplierSupportedApps = "fandomdesktop" | "fandommobile";
type PlatformsCssSelectors = { [key in TopMarginApplierSupportedApps]: string };

export class TopMarginApplier {
  private readonly SELECTORS_TO_MARGIN_BY_APP: PlatformsCssSelectors = {
    fandomdesktop:
      "body.skin-fandomdesktop .main-container .fandom-community-header__background",
    fandommobile: "body.skin-fandommobile nav.mobile-community-bar",
  };
  private readonly ALTERNATIVE_MARGIN_SELECTORS: PlatformsCssSelectors = {
    fandomdesktop: ".community-header-wrapper",
    fandommobile: "",
  };
  private observer: ResizeObserver | undefined;
  private activated: boolean = false;

  constructor(
    private readonly currentApp: string = window.fandomHost?.app ?? "",
  ) {}

  private getElementBySelectorForApp(
    selectors: PlatformsCssSelectors,
  ): HTMLElement | null {
    const selector =
      selectors[this.currentApp as TopMarginApplierSupportedApps];
    if (!selector) return null;

    return document.querySelector(selector);
  }

  private changeElementToMarginForFullScreenBackgrounds(
    baseElement: HTMLElement,
  ): HTMLElement | null {
    const alternativeSelector = this.getElementBySelectorForApp(
      this.ALTERNATIVE_MARGIN_SELECTORS,
    );
    return baseElement.classList.contains("fullScreen")
      ? alternativeSelector
      : baseElement;
  }

  activate(elementObserved: HTMLElement): void {
    if (!tlbHasAdditionalOdysseyWrapper()) {
      this.activated = true;
      const elementToMargin = this.getElementBySelectorForApp(
        this.SELECTORS_TO_MARGIN_BY_APP,
      );
      if (!elementToMargin) return;

      const newElementToMargin =
        this.changeElementToMarginForFullScreenBackgrounds(elementToMargin);

      const handleResize = debounce((entries) => {
        requestAnimationFrame(() => {
          for (const entry of entries as ResizeObserverEntry[]) {
            const newHeight = entry.target.clientHeight;

            if (this.activated) {
              newElementToMargin!.style.marginTop = `${newHeight}px`;
            }
          }
        });
      });

      this.observer = new ResizeObserver(handleResize);
      this.observer.observe(elementObserved);
    }
  }

  reset(): void {
    if (!tlbHasAdditionalOdysseyWrapper()) {
      const elementToMargin = this.getElementBySelectorForApp(
        this.SELECTORS_TO_MARGIN_BY_APP,
      );
      const newElementToMargin =
        this.changeElementToMarginForFullScreenBackgrounds(elementToMargin!);

      if (newElementToMargin) {
        newElementToMargin.style.marginTop = "";
      }
      this.activated = false;
      this.observer?.disconnect();
    }
  }
}
